<!-- 欠费待补交规则 -->
<template>
  <div class="fee-owe-rules" data-test="fee-owe-rules">
    <div class="wrap">
      <van-field label="自动发送补交提醒" label-width="160" input-align="right">
        <template #input>
          <van-switch v-model="params.autoSendFeeNotice" size="20" :active-value="1" :inactive-value="0" @change="autoSendFeeNoticeChange"/>
        </template>
      </van-field>
      <div class="tips">{{params.autoSendFeeNotice?'停用后，系统将不再自动给学员发送补交提醒':'启用后，系统将根据设置规则自动给学员发送补交提醒'}}</div>
      <template v-if="params.autoSendFeeNotice">
        <div class="container-wrap">
          <div class="t1">设置自动提醒规则</div>
          <div class="container">
            下次补交日期的剩余天数&nbsp;≤&nbsp;<van-stepper
              v-model="params.distanceNextPayTime"
              min="0"
              max="999"
              integer
            />&nbsp;天
          </div>
          <div class="container">
            最近&nbsp;<van-stepper
              v-model="params.latelyNotSendNotice"
              min="1"
              max="999"
              integer
            />&nbsp;天未发送过补交提醒
          </div>
          <div class="tips">同时满足以上2个条件的学员，系统将于10:00自动发送补交提醒(未设置“下次补交日期”的学员不会自动提醒）</div>
          <div class="example" @click="showPopover = true">查看消息提醒示例</div>
        </div>
      </template>
    </div>
    <page-footer-btn multipleBtns>
      <van-button square round block 
        @click="cancel" 
        data-test="fee-owe-rules-btn-cancel"
      >取消</van-button>
      <van-button square round block 
        type="primary" 
        @click="save" 
        data-test="fee-owe-rules-btn-save"
        :loading="submiting" 
        >保存</van-button>
    </page-footer-btn>

    <transition name="van-fade">
      <div class="example-layer" v-if="showPopover">
        <div class="example-body">
          <div class="title1">家长收到的微信消息示例</div>
          <div class="title2">学员姓名、交费项目、学校名称、补交费用，将根据实际情况推送。</div>
          <img
            class="non-full"
            src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0088.png"
            alt=""
          />
          <button @click="showPopover = false">我知道了</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  data() {
    return {
      pageTitle: "自动提醒规则",
      params: {
        autoSendFeeNotice: 0,
        distanceNextPayTime: 0,
        latelyNotSendNotice: 0,
      },
      showPopover: false,
      submiting: false,
    }
  },
  methods: {
    getDefaultDatas() { // 获取已有的配置
      this.showLoading();
      this.$api.findFeeOweRule().then(res=> {
        if (res.code == 200) {
          Object.assign(this.params, res.data);
        }
      }).finally(()=>{        
        this.$toast.clear();
      });
    },
    autoSendFeeNoticeChange(e) {
      if (e==1) {
        this.params.distanceNextPayTime = 3;
        this.params.latelyNotSendNotice = 7;
      }
    },
    cancel() {
      this.$router.back();
    },
    save() {
      this.showLoading();
      this.submiting = true;
      this.$api.addFeeOweRule(this.params)
        .then(res=>{        
          this.submiting = false;
          if (res.code === 200) {                    
            app.vue.$emit("refresh-fee-owe-list");
            this.$toast.clear();     
            this.$toast.success('保存成功');
            this.$router.back();
            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(()=>{        
          this.submiting = false; 
        });
    }
  },
  created () {
    this.getDefaultDatas();
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.fee-owe-rules {
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
    .tips {
      margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
      color: var(--g6);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
    }
    .container-wrap {
      .t1 {
        color: var(--g7);
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
      }
      .container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: var(--g7);
        background-color: var(--white);
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      }
      .example {
        float: right;
        margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
        color: var(--c1);
      }
    }
  }
  .example-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.9);
    .example-body {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      .title1 {
        margin: 0 calc(var(--gap) * 16);
        color: var(--white);
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        text-align: center;
      }
      .title2 {
        margin: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        color: var(--white);
        text-align: center;
      }
      img {
        width: 100%;
        height: auto;
        &.non-full {
          display: block;
          width: 90%;
          margin: 0 auto;
        }
      }
      button {
        display: block;
        margin: calc(var(--gap) * 40) auto 0;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 40);
        color: var(--white);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        background-color: transparent;
        border-radius: var(--radius-lg);
        border: 1px solid #ffffff;
        box-shadow: unset;
      }
    }
  }
}
</style>